'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListCover = require('./components/ListCover.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListCover).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-list-cover/lib/index.js
// module id = 1192
// module chunks = 0